<template>
  <div id="app">

    <detect-network @detected-condition="handleConnectivityChange"/>

    <detect-version/>

    <template v-if="$store.state.app.section == 'login'">
      <router-view/>
    </template>

    <template v-if="$store.state.app.section == 'home'">
      <router-view/>
    </template>

    <template v-if="$store.state.app.section == 'app'">
      <header-view />
      <sidebar-view />
      <router-view/>
      <BaseModalPackage/>
    </template>

    <template v-if="$store.state.app.section == 'pos'">
      <router-view/>
    </template>

    <template v-if="$store.state.app.section == 'error'">
      <router-view/>
    </template>

    <template v-if="$store.state.app.section == 'admin'">
      <router-view/>
    </template>

    <template v-if="$store.state.app.section == 'callback'">
      <router-view/>
    </template>

  </div>
</template>

<script>
import HeaderView from '@/components/apps/common/Header.vue'
import SidebarView from '@/components/apps/common/SideBar.vue'
import detectVersion from '@/components/version/DetectVersion.vue'
import detectNetwork from 'v-offline'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    HeaderView,
    SidebarView,
    detectNetwork,
    detectVersion,
  },
  computed: {
    ...mapGetters({
      loading: 'getLoading',
      error: 'getError',
      getLang: 'getLang',
      getSection: 'getSection',
    }),
  },
  methods: {
    ...mapActions([
      'setNetworkStatus',
    ]),
    handleConnectivityChange (e) {
      // online return true, offline return false
      this.setNetworkStatus(e)
    },
    switchLang (lang) {
      // change lang
      this.$i18n.locale = lang
      // switch lang
      this.$store.dispatch('switchLang', lang)
    },
  },
  watch: {
    loading: function (isLoading) {
      this.showLoading(this.$Progress, isLoading)
    },
    error: function (msg) {
      if (typeof msg === 'string') {
        if (msg.search('{DevOnly}') >= 0) {
          console.error(msg)
        } else {
          // messages we don't want to display popup
          const messages = [
            'not found email or username.',
            'password is invalid.',
            'This email is already taken',
            'email is not verify.',
            'I was expecting at least 6 chars in password',
            'SHOP_IS_SUSPENDED',
            'OK',
          ]

          if (messages.indexOf(msg) >= 0) {
            return
          }

          this.showError(this.$Progress, this.$vs, msg, {
            title: this.$t('message.message'),
            text: this.$t('message.somethingwentwrong'),
          })
        }
      }
    },
    getLang: function (after, before) {
      location.reload()
    },
    getSection: function (after, before) {
      let section = after
      if (section === 'home') {
        window.fcWidget.show()
      } else {
        window.fcWidget.hide()
      }
    },
  },
  created() {
    if (this.$route.query.lang) {
      const defaultLang = 'en'
      const langs = [
        'en',
        'th',
        'zh',
        'id',
        'vi',
      ]
      if (langs.includes(this.$route.query.lang)) {
        this.switchLang(this.$route.query.lang)
      } else {
        this.switchLang(defaultLang)
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue